import { FunctionComponent } from 'react';

interface Props {
  progress: number;
}

const ProgressBar: FunctionComponent<Props> = ({ progress }) => {
  return (
    <>
      <div className="w-full bg-neutral-300 h-3 fixed mt-14">
        <div className={`bg-blue-600 h-3`} style={{ width: `${progress}%` }}></div>
      </div>
    </>
  );
};

export default ProgressBar;
